"use client";

// Reps sur la page d'accueil : le produit se démontre mieux qu'il ne se
// raconte. Le bouton mène à /reps, où une leçon est offerte sans compte avant
// le mur d'inscription (RepsSignupGate) : c'est la porte d'entrée la moins
// chère du site, un visiteur y réussit quelque chose avant qu'on lui demande
// quoi que ce soit.
//
// L'aperçu rejoue une leçon en boucle : le code s'écrit, le résultat apparaît,
// la réponse est validée. C'est la seule façon de montrer que Reps se pratique
// au lieu de se regarder. Il reste volontairement schématique : reproduire
// l'interface réelle du player coûte cher et devient faux au premier
// changement.
//
// La démonstration ne tourne QUE pendant qu'elle est à l'écran
// (onViewportEnter / onViewportLeave) et s'efface devant
// prefers-reduced-motion, qui affiche directement l'état final.
//
// DEMOS est un tableau pour qu'ajouter un parcours (Python, no-code) tienne en
// un objet : Reps ne se limitera pas au HTML.

import { useCallback, useEffect, useRef, useState } from "react";
import { motion } from "motion/react";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

// Icônes Solar (480 Design, CC BY 4.0) copiées en dur, comme dans
// SupportLevels : la landing ne doit pas dépendre du chargement distant
// d'Iconify pour afficher trois puces.
const SolarStopwatch = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4.75a7.25 7.25 0 1 0 0 14.5a7.25 7.25 0 0 0 0-14.5M3.25 12a8.75 8.75 0 1 1 17.5 0a8.75 8.75 0 0 1-17.5 0"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 7.25a.75.75 0 0 1 .75.75v3.69l2.28 2.28a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1-.22-.53V8a.75.75 0 0 1 .75-.75M9.25 2a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 2"
            clipRule="evenodd"
        />
    </svg>
);

const SolarKeyboard = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.25 8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v8A2.75 2.75 0 0 1 19 18.75H5A2.75 2.75 0 0 1 2.25 16zM5 6.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M8 15.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zM6 9a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 9m3.25 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75m3.25 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75M15.75 9a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75M6 12a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 12m3.25 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75m3.25 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75m3.25 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75"
        />
    </svg>
);

const SolarFlame = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <g fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M20 13.111C20 20.222 13.956 22 10.933 22C8.29 22 3 20.222 3 13.111c0-2.782 1.461-4.65 2.86-5.716c.778-.594 1.77-.003 1.87.971l.086.838c.105 1.02 1.033 1.857 1.893 1.298C11.394 9.407 12 6.775 12 5.333V5.01c0-1.43 1.444-2.35 2.602-1.512C17.165 5.35 20 8.584 20 13.11Z" />
            <path d="M8 18.445C8 21.289 10.489 22 11.733 22c1.09 0 3.267-.711 3.267-3.555c0-1.102-.59-1.845-1.16-2.274c-.398-.299-.957-.03-1.094.449c-.178.624-.823 1.016-1.152.456c-.3-.512-.3-1.28-.3-1.743c0-.636-.64-1.048-1.155-.674C9.106 15.409 8 16.68 8 18.445Z" />
        </g>
    </svg>
);

const SolarCheck = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m4.03 8.53a.75.75 0 0 0-1.06-1.06l-4.47 4.47l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0z"
            clipRule="evenodd"
        />
    </svg>
);

const points = [
    { key: "short", icon: SolarStopwatch },
    { key: "write", icon: SolarKeyboard },
    { key: "streak", icon: SolarFlame },
];

// Une entrée = un parcours montré dans l'aperçu. `typed` est ce que la
// démonstration écrit ; `before` et `after` encadrent la ligne et restent figés.
const DEMOS = [
    {
        key: "html",
        before: "<body>\n  ",
        typed: "<h1>{title}</h1>",
        after: "\n</body>",
    },
];

const TYPING_STEP_MS = 55;
const PAUSE_BEFORE_CHECK_MS = 500;
const PAUSE_BEFORE_RESTART_MS = 2600;

// Rejoue la leçon : frappe du code, apparition du résultat, validation.
function LessonPreview() {
    const t = useTranslations();
    const demo = DEMOS[0];
    const siteTitle = t("RepsSection_preview_site_title");
    const fullLine = demo.typed.replace("{title}", siteTitle);

    // `phase` : "typing" -> "checked". Le nombre de caractères écrits pilote
    // aussi l'aperçu, qui n'affiche le titre qu'une fois la balise fermée.
    const [typedLength, setTypedLength] = useState(0);
    const [checked, setChecked] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const timers = useRef([]);

    const clearTimers = useCallback(() => {
        timers.current.forEach((id) => clearTimeout(id));
        timers.current = [];
    }, []);

    const prefersReducedMotion =
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    useEffect(() => {
        if (!isPlaying) return undefined;

        // Mouvement réduit : on montre l'état final, sans jamais boucler.
        if (prefersReducedMotion) {
            setTypedLength(fullLine.length);
            setChecked(true);
            return undefined;
        }

        const schedule = (fn, delay) => {
            timers.current.push(setTimeout(fn, delay));
        };

        const runCycle = () => {
            setTypedLength(0);
            setChecked(false);

            for (let index = 1; index <= fullLine.length; index += 1) {
                schedule(() => setTypedLength(index), index * TYPING_STEP_MS);
            }

            const typingDuration = fullLine.length * TYPING_STEP_MS;
            schedule(
                () => setChecked(true),
                typingDuration + PAUSE_BEFORE_CHECK_MS,
            );
            schedule(
                runCycle,
                typingDuration + PAUSE_BEFORE_CHECK_MS + PAUSE_BEFORE_RESTART_MS,
            );
        };

        runCycle();

        return clearTimers;
    }, [isPlaying, prefersReducedMotion, fullLine, clearTimers]);

    useEffect(() => clearTimers, [clearTimers]);

    const typedText = fullLine.slice(0, typedLength);
    const isLineComplete = typedLength >= fullLine.length;

    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            onViewportEnter={() => setIsPlaying(true)}
            onViewportLeave={() => {
                setIsPlaying(false);
                clearTimers();
            }}
            className="rounded-3xl border border-gray-200 bg-white p-5 shadow-xl shadow-gray-200/50 dark:border-grayDark-800 dark:bg-bgDark-500 dark:shadow-none sm:p-7"
        >
            {/* Barre de progression */}
            <div className="flex items-center gap-3">
                <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-gray-100 dark:bg-grayDark-800">
                    <motion.div
                        className="h-full rounded-full bg-primary"
                        initial={false}
                        animate={{ width: checked ? "50%" : "37.5%" }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                    />
                </div>
                <span className="shrink-0 text-xs font-semibold text-gray-400 dark:text-grayDark-500">
                    {checked ? "4 / 8" : "3 / 8"}
                </span>
            </div>

            {/* Consigne. Dans Reps, c'est BeBot qui s'adresse à l'apprenant :
                d'où le tutoiement et l'illustration juste à côté. */}
            <div className="mt-6 flex items-start gap-3">
                <Image
                    src="/images/bebot/bebot-reps.png"
                    alt="BeBot"
                    width={48}
                    height={48}
                    className="h-11 w-11 shrink-0 object-contain"
                />
                <p className="mb-0 rounded-2xl rounded-tl-none bg-gray-50 px-4 py-3 text-[15px] leading-relaxed text-gray-700 dark:bg-white/[0.04] dark:text-grayDark-200">
                    {t("RepsSection_preview_instruction")}
                </p>
            </div>

            {/* Code en cours d'écriture */}
            <div className="mt-5 overflow-x-auto rounded-2xl bg-[#1e1e2e] p-4 font-mono text-[13px] leading-relaxed text-gray-300 sm:text-sm">
                <pre className="mb-0">
                    <code>
                        {demo.before}
                        <span className="text-emerald-300">{typedText}</span>
                        {!isLineComplete && (
                            <span className="ml-px inline-block h-[1.1em] w-[2px] translate-y-[3px] animate-pulse bg-emerald-300" />
                        )}
                        {demo.after}
                    </code>
                </pre>
            </div>

            {/* Rendu obtenu : c'est là que la pratique devient visible */}
            <div className="mt-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 dark:border-grayDark-800 dark:bg-white/[0.02]">
                <span className="text-[10px] font-mono uppercase tracking-widest text-gray-400 dark:text-grayDark-600">
                    {t("reps_preview")}
                </span>
                <motion.p
                    initial={false}
                    animate={{
                        opacity: isLineComplete ? 1 : 0,
                        y: isLineComplete ? 0 : 8,
                    }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    className="mb-0 mt-1 text-2xl font-bold text-gray-900 dark:text-white"
                >
                    {siteTitle}
                </motion.p>
            </div>

            {/* Validation (décoratif : le vrai bouton est dans le player) */}
            <div
                aria-hidden
                className={`mt-4 flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-center text-sm font-bold text-white transition-colors duration-300 ${
                    checked
                        ? "border-b-4 border-b-emerald-700 bg-emerald-500"
                        : "border-b-4 border-b-gray-300 bg-gray-200 text-gray-500 dark:border-b-white/10 dark:bg-white/10 dark:text-grayDark-400"
                }`}
            >
                {checked && <SolarCheck className="h-5 w-5" />}
                {checked ? t("reps_correct_cheer_02") : t("reps_verify")}
            </div>
        </motion.div>
    );
}

export default function RepsSection() {
    const t = useTranslations();

    return (
        <section className="relative mt-32 max-w-7xl mx-auto px-5 xl:px-0">
            {/* En-tête */}
            <div className="text-center">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.5 }}
                    className="rounded-full border border-primary-100 px-4 py-1 uppercase font-light inline text-sm text-primary-100"
                >
                    {t("RepsSection_kicker")}
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{
                        duration: 0.7,
                        delay: 0.1,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    className="dark:text-white md:text-5xl sm:text-4xl text-3xl font-bold lg:px-10 mt-3 sm:leading-relaxed"
                    dangerouslySetInnerHTML={{
                        __html: t.raw("RepsSection_lead"),
                    }}
                />

                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6, delay: 0.25 }}
                    className="mt-5 dark:text-textSecondDark lg:w-7/12 mx-auto"
                    style={{ lineHeight: "170%" }}
                >
                    {t("RepsSection_description")}
                </motion.p>
            </div>

            <div className="mt-14 grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
                {/* Aperçu d'une leçon, rejoué en boucle */}
                <div className="relative order-2 lg:order-1">
                    <LessonPreview />
                </div>

                {/* Arguments et appel à l'action */}
                <div className="order-1 lg:order-2">
                    <ul className="space-y-7">
                        {points.map((point, index) => {
                            const Icon = point.icon;
                            return (
                                <motion.li
                                    key={point.key}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-50px" }}
                                    transition={{
                                        duration: 0.6,
                                        delay: index * 0.12,
                                        ease: [0.22, 1, 0.36, 1],
                                    }}
                                    className="mb-0 flex items-start gap-4"
                                >
                                    <span className="mt-0.5 inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                                        <Icon className="h-6 w-6" />
                                    </span>
                                    <div>
                                        <h3 className="font-sourceSerif text-xl text-gray-900 dark:text-white">
                                            {t(
                                                `RepsSection_point_${point.key}_title`,
                                            )}
                                        </h3>
                                        <p className="mb-0 mt-1 text-[15px] leading-relaxed text-gray-600 dark:text-grayDark-400">
                                            {t(
                                                `RepsSection_point_${point.key}_description`,
                                            )}
                                        </p>
                                    </div>
                                </motion.li>
                            );
                        })}
                    </ul>

                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.6, delay: 0.35 }}
                        className="mt-10"
                    >
                        <Link
                            href="/reps"
                            className="btn-landing btn-3d lip-orange press-safe inline-flex w-full items-center justify-center rounded-full bg-primary px-8 py-3.5 text-sm font-semibold text-white hover:bg-primary/90 sm:w-auto"
                        >
                            {t("RepsSection_cta")}
                        </Link>
                        <p className="mb-0 mt-3 text-sm text-gray-500 dark:text-grayDark-400">
                            {t("RepsSection_cta_note")}
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
